import { Suspense } from "react";
import { styled } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";

import { LegendItemErrorImageFallBack } from "./error/LegendItemErrorImageFallBack";
import { LegendData } from "./LegendData";
import { LegendItemSkeleton } from "components/skeletons/LegendItemSkeleton";
import { ExtendedWMSParams } from "types/types";

interface Props {
  id: number;
  url: string;
  wmsParams: ExtendedWMSParams;
}

export function LegendLoad(props: Props) {
  const { id, wmsParams, url } = props;

  return (
    <LegendStyles className="legend-item" key={`legend-styles-${id}`}>
      <Suspense key={`legend-${id}`} fallback={<LegendItemSkeleton />}>
        <ErrorBoundary
          key={`legend-error-image-${id}`}
          fallbackRender={(fallbackProps) => (
            <LegendItemErrorImageFallBack
              {...fallbackProps}
              url={url}
              wms={wmsParams}
            />
          )}
        >
          <Suspense key={`legend-${id}`} fallback={<LegendItemSkeleton />}>
            <LegendData id={id} wms={wmsParams} url={url} />
          </Suspense>
        </ErrorBoundary>
      </Suspense>
    </LegendStyles>
  );
}

const LegendStyles = styled("div")`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-left: ${({ theme }) => theme.spacing(2.5)};
  .error-icon {
    max-width: 12px;
    max-height: 12px;
  }

  .image-fallback {
    align-self: flex-start;
  }
`;
